function isPlainObject(val: unknown): val is Record<string, unknown> {
  if (typeof val === 'object' && !Array.isArray(val) && val !== null) {
    return Object.getPrototypeOf(val) === Object.prototype;
  }
  return false;
}

export function coerceToBodyInit(body: unknown): BodyInit | undefined {
  if (isPlainObject(body) || Array.isArray(body)) {
    return JSON.stringify(body);
  }
  return body as BodyInit;
}

export function isToasterError(error: unknown) {
  return (
    typeof error === 'object' &&
    error !== null &&
    'errors' in error &&
    typeof (error as { errors: unknown }).errors === 'object' &&
    (error as { errors: { details?: unknown } }).errors?.details !== undefined
  );
}
